import {
  ApiIndividualResponse,
  ApiPaginatedResponse,
  ApiPaginationParams,
} from '@/types/api'
import { IWorkspace } from '@/types/workspace'
import { ApiService, RequestOptions } from './api'

export type IWorkspaceUpdatePayload = Partial<
  Pick<IWorkspace, 'name' | 'description' | 'company' | 'status'>
>

type GetWorkspaceArgs = {
  options?: RequestOptions
}

type ListWorkspacesArgs = {
  pagination?: ApiPaginationParams
  options?: RequestOptions
}

export class WorkspaceService {
  static readonly path = '/workspaces'
  static readonly httpClient = new ApiService()

  static async post(
    payload: ApiWorkspaceCreationPayload,
    options?: RequestOptions
  ): Promise<ApiIndividualResponse<IWorkspace>> {
    return await WorkspaceService.httpClient.post(
      WorkspaceService.path,
      payload,
      options
    )
  }

  static async patch(
    workspaceId: string,
    payload: ApiWorkspaceUpdatePayload,
    options?: RequestOptions
  ): Promise<ApiIndividualResponse<IWorkspace>> {
    if (!workspaceId || !payload) {
      throw new Error('Invalid workspace ID or payload')
    }

    return await WorkspaceService.httpClient.patch(
      `${WorkspaceService.path}/${workspaceId}`,
      payload,
      options
    )
  }

  static async list({
    pagination = {},
    options,
  }: ListWorkspacesArgs = {}): Promise<ApiPaginatedResponse<IWorkspace>> {
    const queryParams = new URLSearchParams()

    if (pagination.page !== undefined) {
      queryParams.append('page', pagination.page.toString())
    }

    if (pagination.limit !== undefined) {
      queryParams.append('limit', pagination.limit.toString())
    }

    const queryString = queryParams.toString()
    const url = queryString
      ? `${WorkspaceService.path}?${queryString}`
      : WorkspaceService.path

    return await WorkspaceService.httpClient.get(url, options)
  }

  static async getById(
    workspaceId: string,
    { options }: GetWorkspaceArgs = {}
  ): Promise<ApiIndividualResponse<IWorkspace>> {
    return await WorkspaceService.httpClient.get(
      `${WorkspaceService.path}/${workspaceId}`,
      options
    )
  }
}
